import axios from 'helpers/axios';

export const getGeneralStats = async () => {
    const { data } = await axios.get('/api/adminapi/stats/info/');

    return data;
};